// // remap jQuery to $.
// (function($) {
//
// 	// trigger when page is ready.
// 	$(document).ready(
// 		function() {
// 			function initializeCardBlock()
// 			{
// 				$('.call-out-card-block').attr('style', 'background-color: red');
// 			}
//
// 			initializeCardBlock();
//
// 			// Initialize dynamic block preview (editor).
// 			if (window.acf) {
// 				window.acf.addAction('render_block_preview/type=call-out-card', initializeCardBlock);
// 			}
// 		})
//
// })(window.jQuery);
